import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, map, take } from 'rxjs/operators';
import { DataAccessService } from './data-access.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';




const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' })
};
export interface OptionType {

}
@Injectable({
  providedIn: 'root'
})
export class StoresService {
  user: any;
  urlUpload!: string;
  private selectedOptionSubject = new BehaviorSubject<OptionType | null>(null);
  constructor(private afs: AngularFirestore, private cas: DataAccessService, private storage: AngularFireStorage, private http: HttpClient) { }


  getStoreAnalytics(platform: string, channel: string, shop: string) {
    return this.afs.doc(`${platform}/${shop}/analytics/${channel}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      })
    );
  }

  getStoreChannelInfo(platform: string, channel: string, shop: string) {
    return this.afs.doc(`${platform}/${shop}/appData/${channel}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      })
    );
  }

  async updateStoreChannelInfo(platform: string, shop: string, channel: string, body: any) {
    return new Promise((resolve, reject) => {
      this.afs.firestore.doc(`${platform}/${shop}/appData/${channel}`).set(body, { merge: true });
      resolve("success channel");
    });
  }

  getStoreVoiceshoppingChannel(platform: string, shop: string, channel: string): any {
    return this.afs.doc(`${platform}/${shop}/appData/voice-shopping/${channel}/appData`).snapshotChanges().pipe(
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      })
    );
  }

  updateNewStoreGeneral(platform: string, shop: string, body: any) {
    return new Promise((resolve, reject) => {
      const batch = this.afs.firestore.batch();
      const ref1 = this.afs.firestore.doc(`${platform}/${shop}`);
      batch.set(ref1, body, { merge: true });
      resolve(batch.commit());
    });
  }

  async updateNewStoreVoiceChannel(platform: string, shop: string, botType: string, body: any) {
    return new Promise((resolve, reject) => {
      const batch = this.afs.firestore.batch();
      const ref3 = this.afs.firestore.doc(`${platform}/${shop}/appData/voice-shopping/${botType}/appData`);
      batch.set(ref3, body, { merge: true });
      resolve(batch.commit());
    });
  }

  async updateNewStoreVoiceShopping(platform: string, shop: string, botType: string, body1: any, body2: any) {
    const batch = this.afs.firestore.batch();
    const ref1 = this.afs.firestore.doc(`${platform}/${shop}/appData/voice-shopping`);
    batch.set(ref1, body1, { merge: true });
    const ref2 = this.afs.firestore.doc(`${platform}/${shop}/appData/voice-shopping/${botType}/appData`);
    batch.set(ref2, body2, { merge: true });
    return await batch.commit();
  }

  updateBotWithStoreinfo(botId: string, body: any) {
    return this.afs.doc(`bots/${botId}`).set(body, { merge: true })
      .then(
        () => {
          console.log('success');
        })
      .catch(
        e => {
          console.log(e);
        });
  }

  getStores(platform: string, userID: string): any {
    return this.cas.getResponseStoresofuser(platform, userID);

  }

  updateBotInfo(botId: string, body: any): Promise<void> {
    return this.afs.doc(`bots/${botId}`).set(body, { merge: true });
  }

  updateStoreInfoNew(path: string, body: any): Promise<void> {
    console.log('updateStoreInfoNew')
    return this.afs.doc(path).set(body, { merge: true });
  }

  generateScript(platform: string, shop: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      return this.afs.firestore.doc(`${platform}/${shop}/appData/scripts`).get().then(doc => {
        if (doc.exists) {
          const data = doc.data() as any;

          // Your script generation logic here...

          const scriptToAdd = `
            <script type="text/javascript">
              // Your generated script...
            </script>`;

          const fileRef = this.storage.ref(`modules/${platform}/${shop}/conversell.js`);
          return fileRef.putString(scriptToAdd, 'raw', { contentType: 'application/javascript' })
            .snapshotChanges()
            .pipe(
              finalize(async () => {
                return resolve(scriptToAdd);
              })
            )
            .subscribe(() => fileRef.getDownloadURL().subscribe(urlUpload => {
              this.urlUpload = urlUpload;
            }));
        } else {
          console.log("No such document!");
          reject("No such document!");
          return 1;
        }
      }).catch(error => {
        console.log("Error getting document:", error);
        return error;
      });
    });
  }

  getStoreChannelInfoNew(platform: string, channel: string, shop: string): Observable<any> {
    return this.afs.doc(`${platform}/${shop}/appData/${channel}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      })
    );
  }

  getStore(platform: string, shop: string): Observable<any> {
    return this.afs.doc(`${platform}/${shop}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      })
    );
  }

  getStoreCatalogs(path: string): Observable<any> {
    return this.cas.getCatalogsofstore(path);
  }

  getStoreGeneralStats(platform: string, shop: string, channel: string): Observable<any> {
    return this.afs.doc(`${platform}/${shop}/analytics/${channel}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...{ data }
        };
      })
    );
  }
  
  async updateNewStoreConversationalShopping(platform, shop, botType, body1, body2) {

    var batch = this.afs.firestore.batch();
    var ref1 = this.afs.firestore.doc(`${platform}/${shop}`);
    batch.set(ref1, body1, { merge: true });
    var ref2 = this.afs.firestore.doc(`${platform}/${shop}/appData/conversational-shopping`);
    batch.set(ref2, body2, { merge: true });
    return await batch.commit();
  }

  selectedOption$: Observable<any> = this.selectedOptionSubject.asObservable();
  
  setSelectedOption(option: string | null) {
    console.log('here i am changed', option)
    this.selectedOptionSubject.next(option);
  }

  clearSelectedOption() {
    console.log('clean function')
    this.selectedOptionSubject.next(null);  // Réinitialiser la valeur
  }


}
